Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Lightbox = Marionette.Behavior.extend({
        ui: {
            imgHolder: '.img_holder',
            layerVideo: '.layer_video'
        },
        events: {
            'keydown @ui.imgHolder': 'openPhotoLightboxDebounced',
            'click @ui.imgHolder': 'openPhotoLightboxDebounced',
            'click @ui.layerVideo': 'openVideoLightboxDebounced'
        },
        initialize: function() {
            this.openPhotoLightboxDebounced = _.debounce(this.openPhotoLightbox, 300, true);
            this.openVideoLightboxDebounced = _.debounce(this.openVideoLightbox, 300, true);
        },
        onShow: function() {
            if (typeof gon.show_lightbox !== 'undefined' && _.isFalsy(gon.show_lightbox)) {
                this.ui.imgHolder.addClass('noClick');
                this.ui.layerVideo.addClass('noClick');
            }
        },
        openPhotoLightbox: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }

            var obj = {
                sortType: gon.sortType,
                widget: gon.widget,
                perPage: this.getPageSize()
            };

            var message = {
                name: 'pixlee:open:lightbox',
                type: 'action',
                source: 'widget',
                destination: 'lightbox',
                data: {
                    modelData: JSON.stringify(this.view.model.collection.toJSONForLightbox()),
                    indexToOpen: this.view.model.collection.indexOf(this.view.model),
                    variables: JSON.stringify(obj),
                    current_album: App.request('get:current:album').toJSON(),
                    display_options: App.request('get:display:options').toJSON(),
                    usingKeyboard: ev.type === 'keydown'
                }
            };

            window.lastElement = this.ui.imgHolder;
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        openVideoLightbox: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }
            
            ev.preventDefault();
            var obj = {
                sortType: gon.sortType,
                widget: gon.widget,
                perPage: this.getPageSize()
            };

            var message = {
                name: 'pixlee:open:lightbox',
                type: 'action',
                source: 'widget',
                destination: 'lightbox',
                data: {
                    modelData: JSON.stringify(this.view.model.collection.toJSONForLightbox()),
                    indexToOpen: this.view.model.collection.indexOf(this.view.model),
                    variables: JSON.stringify(obj),
                    current_album: App.request('get:current:album').toJSON(),
                    display_options: App.request('get:display:options').toJSON(),
                    usingKeyboard: ev.type === 'keydown'
                }
            };

            window.lastElement = this.ui.imgHolder;
            window.parent.postMessage(JSON.stringify(message), '*');

        },
        getPageSize: function() {
            try {
                return this.view.model.collection.perPage;
            } catch (err) {
                return 0;
            }
        }
    });

});